import logoImg from "@/assets/logo.png";

interface LogoProps {
  size?: number;
  className?: string;
}

export default function Logo({ size = 32, className }: LogoProps) {
  return (
    <img
      src={logoImg}
      alt="cenik.ai"
      width={size}
      height={size}
      className={`relative top-[1px] ${className || ""}`}
    />
  );
}
